/**
 * Contraintes de capture + plafonds de bitrate — extraits pour être testables
 * sans `RTCPeerConnection`/`getUserMedia` réels (jsdom n'implémente pas
 * WebRTC, même logique d'extraction que `negotiation.ts`).
 *
 * `getUserMedia`/`getDisplayMedia` n'avaient auparavant AUCUNE contrainte
 * (`{video: true}`) — le navigateur choisissait sa résolution par défaut,
 * souvent basse. `ideal` (jamais `min`/`exact`) garantit une dégradation
 * gracieuse plutôt qu'un `OverconstrainedError` sur un appareil limité.
 */

export const CAMERA_VIDEO_CONSTRAINTS: MediaTrackConstraints = {
  width: { ideal: 1280 },
  height: { ideal: 720 },
  frameRate: { ideal: 30 },
};

/** Le contenu d'écran favorise la netteté (texte lisible) sur la fluidité. */
export const SCREEN_SHARE_VIDEO_CONSTRAINTS: MediaTrackConstraints = {
  width: { ideal: 1920 },
  height: { ideal: 1080 },
  frameRate: { ideal: 15 },
};

export const CAMERA_MAX_BITRATE_BPS = 2_500_000;
export const SCREEN_SHARE_MAX_BITRATE_BPS = 4_000_000;

/** Sender vidéo d'une RTCPeerConnection — même prédicat pour caméra et écran (kind ne change jamais). */
export function pickVideoSender<T extends { track: { kind: string } | null }>(
  senders: readonly T[],
): T | undefined {
  return senders.find((s) => s.track?.kind === 'video');
}
